import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./style.css";

const Seat = ({ fill }) => (
  <span className={cx("seat", { [`seat--${fill}`]: fill })} />
);

Seat.propTypes = {
  fill: PropTypes.oneOf(["empty", "filled", "active"])
};

Seat.defaultProps = {
  fill: "empty"
};

export default Seat;



// WEBPACK FOOTER //
// ./src/components/Seat/index.js